// extracted by mini-css-extract-plugin
module.exports = {"container":"Menu_container__H3rKe","gameInfo":"Menu_gameInfo__19Emn"};